import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { default as Scheme$79ef } from '/web/schemes/bearerStrategy.js'
import { default as Scheme$f546 } from '/web/schemes/customOauth2Scheme.js'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": false,
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/",
      "maxAge": 2592000
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "custom",
  "local": false
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // custom
  $auth.registerStrategy('custom', new Scheme$79ef($auth, {
  "user": {
    "property": false,
    "autoFetch": true
  },
  "endpoints": {
    "login": {
      "url": "/auth/token/",
      "method": "post"
    },
    "logout": false,
    "refresh": {
      "url": "/auth/refresh/",
      "method": "post"
    },
    "user": {
      "url": "/users/me/",
      "method": "get"
    }
  },
  "token": {
    "required": true,
    "type": "Bearer",
    "property": "access_token",
    "global": true,
    "maxAge": 2592000
  },
  "refreshToken": {
    "property": "refresh_token",
    "data": "token",
    "maxAge": 5184000
  },
  "name": "custom"
}))

  // google
  $auth.registerStrategy('google', new Scheme$f546($auth, {
  "endpoints": {
    "authorization": "https://vistat.org/api-v2/auth/google_login/",
    "userInfo": {
      "url": "/users/me/",
      "method": "get"
    }
  },
  "token": {
    "property": "access_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "data": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "codeChallengeMethod": "",
  "name": "google",
  "scope": [
    "openid",
    "profile",
    "email"
  ]
}))

  // vk
  $auth.registerStrategy('vk', new Scheme$f546($auth, {
  "endpoints": {
    "authorization": "https://vistat.org/api-v2/auth/vk_login/",
    "userInfo": {
      "url": "/users/me/",
      "method": "get"
    }
  },
  "token": {
    "property": "access_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "data": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "codeChallengeMethod": "",
  "name": "vk"
}))

  // yandex
  $auth.registerStrategy('yandex', new Scheme$f546($auth, {
  "endpoints": {
    "authorization": "https://vistat.org/api-v2/auth/yandex_login/",
    "userInfo": {
      "url": "/users/me/",
      "method": "get"
    }
  },
  "token": {
    "property": "access_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "data": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "codeChallengeMethod": "",
  "name": "yandex"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
